import{toFixed as m}from"./toFixed.min.mjs";import{config as o}from"../../config.min.mjs";const i=i=>"matrix("+i.map((i=>m(i,o.NUM_FRACTION_DIGITS))).join(" ")+")";export{i as matrixToSVG};
//# sourceMappingURL=svgExport.min.mjs.map
